<template>
  <div :class="{ 'activation-buttons': true, 'in-search': inSearch }">
    <v-btn small depressed color="#b8e994" @click="openMembershipUrl">
      <v-icon small left> mdi-link </v-icon>
      <span>Webshop aktivacija</span>
    </v-btn>

    <v-btn small depressed color="#b8e994" @click="copyMembershipUrl">
      <v-icon small left v-if="!copySuccess">mdi-content-copy</v-icon>
      <v-icon small left v-else>mdi-check</v-icon>
      <span>{{ copySuccess ? "Kopirano!" : "Kopiraj webshop link" }}</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ["member", "inSearch"],

  data() {
    return {
      copySuccess: false,
    };
  },

  computed: {
    parseMembershipUrl() {
      const baseUrl = "https://clan.hajduk.hr/";
      const url = new URL(baseUrl);

      const m = this.member;

      if (m.FirstName) {
        url.searchParams.append("firstName", m.FirstName);
      }
      if (m.LastName) {
        url.searchParams.append("lastName", m.LastName);
      }
      if (m.npe01__HomeEmail__c) {
        url.searchParams.append("email", m.npe01__HomeEmail__c);
      }
      if (m.Birthdate) {
        url.searchParams.append("birthdate", m.Birthdate);
      }
      if (m.Member_ID__c) {
        url.searchParams.append("memberId", m.Member_ID__c);
      }
      if (m.Primary_Affiliate__c) {
        url.searchParams.append("mbase", m.Primary_Affiliate__c.slice(0, -3));
      }
      if (m.MobilePhone) {
        url.searchParams.append("mobile", m.MobilePhone);
      }

      return url.toString();
    },
  },

  methods: {
    openMembershipUrl() {
      if (this.parseMembershipUrl) {
        window.open(this.parseMembershipUrl, "_blank");
      }
    },
    async copyMembershipUrl() {
      if (this.parseMembershipUrl) {
        try {
          await navigator.clipboard.writeText(this.parseMembershipUrl);
          this.copySuccess = true;
          setTimeout(() => {
            this.copySuccess = false;
          }, 2000);
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.activation-buttons {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;

  &.in-search {
    align-items: flex-end;
    margin-top: 10px;
  }
}
</style>
